import React from "react";
import {connect} from "react-redux";
import Header from "../../common/components/Header";
import TextInput from "./TextInput";
import SubmitButton from "../../recorder/components/SubmitButton";
import { userDetailsAttributesChanged, saveUserDetails } from "../actions/authenticationActions";
import {MAIN_CONTENT} from "../../styles";

export const UserDetailsForm = (props) => {
    return (
        <div style={MAIN_CONTENT}>
            <Header>Fill in your details</Header>
            <div className="pure-form pure-form-aligned">
                <div style={{borderBottom: "1px solid #ddd", padding: 10}}>
                    <TextInput attribute="jobRole" {...props} >Job title</TextInput>
                    <TextInput attribute="regulatingAuthority" {...props} >Regulating authority</TextInput>
                </div>

                <div style={{backgroundColor: "#eee", padding: 10}}>
                    <div style={{marginLeft: "11em"}}>
                        <SubmitButton disabled={props.recordingInProgress}
                                      onSubmit={props.onSubmit}>
                            { props.recordingInProgress ? "Recording..." : "Register" }
                        </SubmitButton>
                    </div>
                </div>
            </div>
        </div>
    );
};
UserDetailsForm.propTypes = {
    jobRole: React.PropTypes.string,
    regulatingAuthority: React.PropTypes.string,
    attributesWithErrors: React.PropTypes.arrayOf(React.PropTypes.string),
    onAttributesChange: React.PropTypes.func
};
UserDetailsForm.defaultProps = {
    attributesWithErrors: []
};

export const mapStateToProps = (state) => ({
    attributesWithErrors: state.authentication.userDetails.attributesWithErrors
});

export const mapDispatchToProps = (dispatch, ownProps) => ({
    onAttributesChange: attributes => dispatch(userDetailsAttributesChanged(attributes)),
    onSubmit: () => dispatch(saveUserDetails())
});

export default connect(mapStateToProps, mapDispatchToProps)(UserDetailsForm);



/** WEBPACK FOOTER **
 ** ./src/main/javascript/authentication/components/UserDetailsForm.js
 **/